import { mark } from '../perf';
import { client } from '../amplify';

/**
 * @desc Recursively fetch all items in a list query using nextToken
 * @param {Object} query The query object from cda-graphql in use.
 * @param {Object} variables The variables to pass to query.
 * @param {Array} items Any preliminary Items already fetched
 * @param {Function} callback Optional callback function to be fired with every batch of items from query iteration.
 * @param {Number} nextLimit Optional page size for every page after the first, so the first can be small.
 * @returns {Array} Array of all items received from queries.
 */
export async function fetchItemsNextToken({
  query,
  variables,
  items = [],
  callback = undefined,
  nextLimit = undefined,
}) {
  const { data } = await client.graphql({ query: query, variables: variables });
  //const key = Object.keys(data).find(k => k.includes('items'));
  const key = Object.keys(data)[0];
  const res = data[key]; // res = { items: [], nextToken: '' }

  items.push(...res.items);
  mark(`page:${key}:${items.length}`);
  if (callback) {
    callback(res.items);
  }
  if (!res.nextToken) return items;

  // eslint-disable-next-line no-param-reassign
  variables.nextToken = res.nextToken;
  if (nextLimit) {
    // eslint-disable-next-line no-param-reassign
    variables.limit = nextLimit;
  }
  return fetchItemsNextToken({ query, variables, items, callback });
}
